module.exports = __webpack_public_path__ + "img/bckarw.97f5c8d0.svg";